import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-h5" }

import { isEmpty, isEqual, pickBy } from 'lodash'
import { Ref, ref } from 'vue'
import UsersForm from './UsersForm.vue'
import { CardHeader } from '../../../../components'
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'

import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import {
  RolesService,
  ControlQuestionsService,
  CardIssuePointsService,
  UsersService,
  User,
  MunicipalEntitiesService,
  AppAuthService,
  Id,
} from '@prodcard/core'
import { useRouter } from 'vue-router'
import { UserOpts } from '../interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersEditPage',
  props: {
    usersService: {},
    rolesService: {},
    controlQuestionsService: {},
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    authService: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()

const user: Ref<User | undefined> = ref(undefined)
const loading = ref(false)
const userLoaded = ref(true)
const disabled = ref(false)

handleError(async () => {
  user.value = await props.usersService.findById(createCtx(), props.id)
}, userLoaded)

const updateUser = (userOpts: UserOpts) => {
  handleError(async () => {
    if (!user.value) return

    const opts = pickBy(userOpts, (val, key) => {
      if (!val && !user.value?.[key as keyof typeof user.value]) return false
      if (!isEqual(user.value?.[key as keyof typeof user.value], val)) return true
      return !val
    })

    if (isEmpty(opts)) return
    await props.usersService.update(createCtx(), user.value.id, opts)
    callSuccessToast('Данные пользователя сохранены')
    router?.back()
  }, loading)
}

const deleteUser = (id?: Id) => {
  if (!id) return
  handleError(async () => {
    await props.usersService.delete(createCtx(), id)
    callSuccessToast('Пользователь удален')
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            loading: loading.value || userLoaded.value || disabled.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardHeader), null, {
                    default: _withCtx(() => [
                      (user.value && !userLoaded.value)
                        ? (_openBlock(), _createBlock(_component_v_list, {
                            key: 0,
                            class: "pa-0 bg-transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                title: user.value.name + ' ' + user.value.surname,
                                subtitle: user.value.email
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_avatar, {
                                    color: "primary",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_1, _toDisplayString(user.value.name[0] + user.value.surname[0]), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["title", "subtitle"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_unref(VSkeletonLoader), {
                            key: 1,
                            width: "350",
                            class: "bg-transparent",
                            type: "list-item-avatar-two-line"
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
                default: _withCtx(() => [
                  (user.value && !userLoaded.value)
                    ? (_openBlock(), _createBlock(UsersForm, {
                        key: 0,
                        user: user.value,
                        "roles-service": _ctx.rolesService,
                        "card-issue-points-service": _ctx.cardIssuePointsService,
                        "control-questions-service": _ctx.controlQuestionsService,
                        "municipal-entities-service": _ctx.municipalEntitiesService,
                        "auth-service": _ctx.authService,
                        loading: loading.value,
                        disabled: loading.value || userLoaded.value || disabled.value,
                        onSubmit: updateUser,
                        onDelete: deleteUser
                      }, null, 8, ["user", "roles-service", "card-issue-points-service", "control-questions-service", "municipal-entities-service", "auth-service", "loading", "disabled"]))
                    : (_openBlock(), _createBlock(_unref(VSkeletonLoader), {
                        key: 1,
                        type: "heading@8, actions"
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})